export function leadingZeroBits(bytes) {
  let bits = 0;
  for (let i = 0; i < bytes.length; i += 1) {
    const value = bytes[i];
    if (value === 0) {
      bits += 8;
      continue;
    }
    bits += 7 - Math.floor(Math.log2(value));
    break;
  }
  return bits;
}

function webCrypto() {
  // globalThis is the window on the page and self inside the Web Worker.
  // eslint-disable-next-line no-undef
  return typeof globalThis !== "undefined" ? globalThis.crypto : undefined;
}

export function canRunPow() {
  return typeof Worker !== "undefined" && Boolean(webCrypto()?.subtle);
}

export async function subtleDigest(salt, nonce, subtle = webCrypto()?.subtle) {
  const data = new TextEncoder().encode(`${salt}:${nonce}`);
  return new Uint8Array(await subtle.digest("SHA-256", data));
}

export async function findPowNonce(salt, difficulty, digest, options = {}) {
  const { signal, onProgress, batchSize = 250 } = options;
  const target = 2 ** difficulty;
  let nonce = 0;
  while (!signal?.aborted) {
    const end = nonce + batchSize;
    for (; nonce < end; nonce += 1) {
      const text = String(nonce);
      const hash = await digest(salt, text);
      if (leadingZeroBits(hash) >= difficulty) {
        return text;
      }
    }
    if (onProgress) {
      onProgress(Math.min(95, (nonce / target) * 100));
    }
  }
  return null;
}
